/* oxlint-disable react/only-export-components */
import React, { createContext, useContext, useEffect, useState } from 'react';
import { Socket } from 'socket.io-client';
import { getSocket } from '../socket';

interface SocketContextType {
  socket: Socket | null;
}

const SocketContext = createContext<SocketContextType>({ socket: null });

export const SocketProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [socketInstance, setSocketInstance] = useState<Socket | null>(getSocket());

  useEffect(() => {
    const interval = setInterval(() => {
      const current = getSocket();
      if (current !== socketInstance) {
        setSocketInstance(current);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [socketInstance]);

  return (
    <SocketContext.Provider value={{ socket: socketInstance }}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);
